export default "__VITE_ASSET__GM6U1Hwd__"